import { snakeCase, text, timestamp, varchar } from 'drizzle-orm/pg-core'
import { id, timestamps } from '../utils/columns.helpers'
import { serviceProviderCategoriesTable } from './service-provider-categories.table'

export const vendorsTable = snakeCase.table('vendors', {
    id: id('vnd'),
    restauthOrganizationId: varchar({ length: 255 }).notNull().unique(),
    categoryId: text()
        .notNull()
        .references(() => serviceProviderCategoriesTable.id, {
            onDelete: 'restrict',
            onUpdate: 'cascade',
        }),
    name: varchar({ length: 255 }).notNull(),
    description: text(),
    logoUrl: text(),
    contactEmail: varchar({ length: 255 }),
    contactPhone: varchar({ length: 30 }),
    activatedAt: timestamp({ withTimezone: true }).defaultNow(),
    suspendedAt: timestamp({ withTimezone: true }),
    lastLoginAt: timestamp({ withTimezone: true }),
    ...timestamps,
})
